import useFetchInventoryStatus from '../../../core/apiHooks/useFetchInventoryStatus';
import { useAppSelector } from '../../../core/utils';
import { selectCurrentModelVehiclesByTransmissionAndColor } from '../../../core/reducers/vehicleListFilters';
import { InventoryAvailabilityStatus } from '../../../core/apis/inventoryApi';
import getVehiclesByInventoryStatus from '../utils/getVehiclesByInventoryStatus';
import useFirstTransmissionPayments from './useFirstTransmissionPayments';
const useInventoryStatusAndPrice = (shouldFetch = true) => {
    const { isLoading, isFetching, error, isUninitialized } = useFetchInventoryStatus(shouldFetch, {
        refetchOnMountOrArgChange: true,
        shouldResetStatus: true,
    });
    const vehicles = useAppSelector(selectCurrentModelVehiclesByTransmissionAndColor);
    const inStockVehicles = getVehiclesByInventoryStatus(vehicles, InventoryAvailabilityStatus.inStock);
    const onItsWayVehicles = getVehiclesByInventoryStatus(vehicles, InventoryAvailabilityStatus.onItsWay);
    const dealerInventory = [...inStockVehicles, ...onItsWayVehicles];
    const paymentsResponse = useFirstTransmissionPayments(dealerInventory, shouldFetch);
    return {
        dealerInventory: { inStock: inStockVehicles, onItsWay: onItsWayVehicles },
        isFetching,
        isLoading,
        isUninitialized,
        error,
        paymentsResponse,
    };
};
export default useInventoryStatusAndPrice;
